import styles from "./index.module.css";

export default function FakeButton({
  onClick,
  children,
  className,
  beige,
  orange,
  disabled,
  blue,
  red,
}) {
  return (
    <div
      className={
        styles.button +
        (className ? " " + className : "") +
        (beige ? " " + styles.beige : "") +
        (orange ? " " + styles.orange : "") +
        (disabled ? " " + styles.disabled : "") +
        (blue ? " " + styles.blue : "") +
        (red ? " " + styles.red : "")
      }
      onClick={onClick}
    >
      {children}
    </div>
  );
}
